<template>
  <Modal v-model="show" :mask-closable="false"  @on-ok="update" :loading="loading">
    <div slot="header" class="modal-header">修改功能区</div>   
     <form-list ref="update" :initFormData="initFormData" :projectList="projectList" :n="n" ></form-list>    
  </Modal>
</template>
<script type="text/ecmascript-6">
import { updateFunctionalarea } from "api/functionalArea";
import FormList from './FormItem';
export default {
  props:{   
    n:{
      type:Number,
      default:0
    },
    projectList:{
      type:Array,
      default:null
    },
    initFormData:{
      type:Object,
      default:null
    }
  },
  components: {
        FormList  
    },
  mounted(){
    // console.log(this.initFormData)
  },
  data () {
    return {
      show:false,
      loading:true
    };
  },
 watch:{
   n(val){
     this.show = true;
   },
   initFormData:{
     deep:true,
     handler(val){
      // console.log(val)
     }
   }
 },
 methods:{
   changeLoading() {
      this.loading = false;
      this.$nextTick(() => {
          this.loading = true
      })
  },
   update(){
     let params = this.$refs['update'].formValidate();
     if(!params){
       this.changeLoading()
       return
     }
    updateFunctionalarea(params).then(res => {       
      this.changeLoading();
      this.$Message.success('修改成功');
      this.show = false;
      this.$emit('refresh')
    }).catch(error => {
      this.changeLoading(); 
    })
   }
 }
}
</script>
